(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["frequency-recommendations"] && !Shopify.designMode) return;
  try {
    
(function () {
  const breakpoint = 767;
  const debounceDelay = 150;
  let resizeTimer;

  function updateHeights() {
    const titles = document.querySelectorAll('.frequency-section h4');
    const ranges = document.querySelectorAll('.frequency-section .range-wrapper');

    if (window.innerWidth < breakpoint) {
      titles.forEach(t => (t.style.minHeight = ''));
      ranges.forEach(r => (r.style.minHeight = ''));
      return;
    }

    titles.forEach(t => (t.style.minHeight = ''));
    ranges.forEach(r => (r.style.minHeight = ''));

    let maxTitleHeight = 0;
    let maxRangeHeight = 0;

    titles.forEach(t => { maxTitleHeight  = Math.max(maxTitleHeight,  t.offsetHeight); });
    ranges.forEach(r => { maxRangeHeight = Math.max(maxRangeHeight, r.offsetHeight); });

    titles.forEach(t => (t.style.minHeight  = maxTitleHeight  + 'px'));
    ranges.forEach(r => (r.style.minHeight = maxRangeHeight + 'px'));
  }

  document.addEventListener('DOMContentLoaded', updateHeights);
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateHeights, debounceDelay);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
